import { LEVEL, LEVEL_PROPERTIES } from '@/interfaces/level.interface'
import { Room } from '@/interfaces/room.interface'
import { orderOnLevel } from '@/utils/sort'
import mergeLevels from './merge-levels'
import adjustHeights from './adjust-heights'

export type LEVEL_SOURCE_OBJECT = {
  type: 'geojson'
  data: {
    id: 'sourceLevel'
    type: 'FeatureCollection'
    features: LEVEL[]
  }
}

export type ROOM_SOURCE_OBJECT = {
  type: 'geojson'
  data: {
    id: 'rooms'
    type: 'FeatureCollection'
    features: Room[]
  }
}

function calculateLevelSource(
  buildingGeometry: GeoJSON.Polygon | GeoJSON.MultiPolygon,
  features: LEVEL[],
  properties: LEVEL_PROPERTIES[],
  minHeight: number = 3,
  gap: number = 0.5,
  base: number = 0
): LEVEL_SOURCE_OBJECT {
  const merged = mergeLevels(buildingGeometry, features, properties).sort(orderOnLevel)
  const adjusted = adjustHeights(merged, minHeight, gap, base)
  const result: LEVEL_SOURCE_OBJECT = {
    type: 'geojson',
    data: {
      id: 'sourceLevel',
      type: 'FeatureCollection',
      features: adjusted
    }
  }
  return result
}

export default calculateLevelSource
